import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { styleConfigs } from '../../../resources/styleConfigs';

export const ListNotificationRootStyled = styled(Box)(({ 'data-visible': visible }: { 'data-visible': string }) => ({
  display: visible === 'true' ? 'flex' : 'none',
  flexDirection: 'column',
  rowGap: styleConfigs.marginPadding.custom20,
  position: 'fixed',
  top: styleConfigs.marginPadding.custom30,
  right: styleConfigs.marginPadding.custom30,
  zIndex: 10001,
  width: styleConfigs.dimensions.auto,
  '@media (max-width: 600px)': {
    left: styleConfigs.marginPadding.custom30,
    right: styleConfigs.marginPadding.custom30,
    width: styleConfigs.dimensions.auto,
  },
}));
